import { AllocateSingleId } from "../AllocateId";
import { GetMasterTableEntries } from "../GetMasterTableEntries";
import { DeleteFromServer, FetchFromServer, SaveToServer } from "../Post";

const MasterTableName = "GAAProductMaster";
const FetchRequestType = "GAAProductFetchRequest";

export const GetGAAProductModesMaster = async (Ref) => {
  let payload = { GAAProductRefs: [Ref] };
  let td = await FetchFromServer(payload, FetchRequestType, []);
  let resultList = GetMasterTableEntries(td, MasterTableName);
  if (resultList.length > 0) {
    return resultList[0];
  }
  return null;
};

export const SaveGAAProductModesMaster = async (ref, payload) => {
  payload["Ref"] = await AllocateSingleId(ref);
  return await SaveToServer(payload, MasterTableName, []);
};

export const DeleteGAAProductModesMaster = async (payload) => {
  return await DeleteFromServer(payload, MasterTableName);
};

export const GetGAAProductModesMasterList = async () => {
  let payload = { GAAProductRefs: [] };
  let td = await FetchFromServer(payload, FetchRequestType, []);
  let result = GetMasterTableEntries(td, MasterTableName);
  result = result.sort((a, b) => a.Ref - b.Ref);
  return result;
};
